import { OptionType } from '@/components/inputs/types';
import { i18n } from '@/utils/i18n';

export const giftRecurringOptions: OptionType[] = [
  {
    label: i18n.t('donation_options.week'),
    value: 'WEEK'
  },
  {
    label: i18n.t('donation_options.month'),
    value: 'MONTH'
  },
  {
    label: i18n.t('donation_options.year'),
    value: 'YEAR'
  }
];

export const predefinedValues = ['10', '50', '100', '1000'];
export const giftTypes: OptionType[] = [
  { label: i18n.t('donation_options.one_time'), value: 'one-time' },
  { label: i18n.t('donation_options.recurring'), value: 'recurring' }
];
